/**
 *  A dedicated Reducer for My Team List
 */

const initState = {
    list : null,
    team_list : [],
    sub_department : [],
    team_schedule: { data: [], date_list: [], week_list: [] },
    filters : {},
    current_page : 0,
    last_page : 0
}

const myTeamListReducers = (state = initState, action) => {
    let message = "";
    let result = {...state};
    switch(action.type) {
        case "FETCH_MY_TEAM_LIST_SUCCESS":
            return {
                ...state,
                list : action.list
            }
            break;
        case "FETCH_TEAM_LIST_SUCCESS":
            return {
                ...state,
                team_list : action.list
            }
            break;
        case "SET_MY_TEAM_LIST_FILTERS":
            return {
                ...state,
                filters : action.filters
            } 
            break;
        case "FETCH_TEAM_UNDER_DEPARTMENT_LIST_SUCCESS":
            return {
                ...state,
                team_list : action.list
            } 

            case "FETCH_SUB_DEPARTMENT_LIST_SUCCESS":
                return {
                    ...state,
                    sub_department : action.list
                } 
        /**  */
        
        
        default:
            result = state;
    }
    return result;
}

export default myTeamListReducers;